import api from './api';
import { CompositePattern } from '../types';

const compositePatternService = {
  async getAll(params?: { container?: number | string | null }): Promise<CompositePattern[]> {
    const queryParams: any = {};
    if (params?.container !== undefined) {
      queryParams.container = params.container === null ? 'null' : params.container;
    }
    const response = await api.get('/composite-patterns/', { params: queryParams });
    return Array.isArray(response.data) ? response.data : response.data.results || [];
  },

  async get(id: number): Promise<CompositePattern> {
    const response = await api.get(`/composite-patterns/${id}/`);
    return response.data;
  },

  async create(data: Partial<CompositePattern>): Promise<CompositePattern> {
    const response = await api.post('/composite-patterns/', data);
    return response.data;
  },

  async update(id: number, data: Partial<CompositePattern>): Promise<CompositePattern> {
    const response = await api.patch(`/composite-patterns/${id}/`, data);
    return response.data;
  },

  async delete(id: number): Promise<void> {
    await api.delete(`/composite-patterns/${id}/`);
  },

  async reorder(items: { id: number; order: number }[]): Promise<void> {
    await api.post('/composite-patterns/reorder/', { items });
  },
};

export default compositePatternService;
